/* --------------------------------------------------------------------------
   Sticky upgrade bar

   Markup: <div class="mtm-sticky" data-sticky-cta
             data-hide-desktop="<selectors>"   the buy box sections
             data-hide-mobile="<selectors>">   the buy boxes' Upgrade buttons

   The bar is visible whenever none of the current breakpoint's hide targets is
   in the viewport, so it never competes with a CTA the visitor can already see.

   The targets differ by breakpoint on purpose. On desktop the buy box and its
   button are on screen together, so the whole section is the right trigger. On
   a phone the box is several screens tall, so hiding on the section would leave
   the visitor with no CTA for most of its height — there the button is the
   trigger.
   -------------------------------------------------------------------------- */
(function () {
  var MOBILE = '(max-width: 767px)';

  function init() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;

    // Re-parent to <body> so no section wrapper (transform, overflow, filter)
    // can become the containing block for position: fixed.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    var targets = [];
    var pending = false;
    var shown = null;

    function collectTargets() {
      var attr = window.matchMedia(MOBILE).matches ? 'data-hide-mobile' : 'data-hide-desktop';
      var selector = bar.getAttribute(attr);
      targets = selector ? Array.prototype.slice.call(document.querySelectorAll(selector)) : [];
    }

    function update() {
      pending = false;
      var vh = window.innerHeight;
      var covered = targets.some(function (el) {
        var r = el.getBoundingClientRect();
        // ignore anything hidden at this breakpoint (zero-size rect)
        if (!r.width && !r.height) return false;
        return r.top < vh && r.bottom > 0;
      });
      var show = !covered;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function onScroll() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    }

    function onResize() {
      collectTargets(); // breakpoint may have flipped
      onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    collectTargets();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
